var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell-render-competitor-display"},[_c('v-icon',{attrs:{"small":"","color":_vm.iconColor}},[_vm._v(" mdi-"+_vm._s(_vm.iconName)+" ")]),_c('span',{staticClass:"cell-render-competitor-display-text"},[_vm._v(_vm._s(_vm.params.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }